interface Props {
    value: string
    onChange: (value: string) => void
    options: string[]
    disabled?: boolean
}
export function SimpleSelect({value, onChange, options, disabled}: Props) {
    return <select value={value} onChange={(e) => onChange(e.target.value)} disabled={disabled}>
        {options.map((option) => <option
            key={option}
            value={option}
        >{option}</option>)}
    </select>

}